import {User} from "@/models/user.model";

export function getDifferenceBetweenArraysOfUsers(a: User[], b: User[]): User[] {
    return a.filter((user) => {
        return !b.map(bUser => bUser.userID).includes(user.userID);
    });
}

/**
 * inverse toutes les positions des éléments d'un tableau. (ne modifie pas le tableau d'origine)
 * principe d'algorithme: Shuffle de type Fisher-Yates
 * @param items
 */
export function shuffleArrayNoFixedPoint<T>(items: T[]): T[] {
  if (items.length < 2) {
    return items;
  }
  const arr = structuredClone(items);
  for (let i = arr.length - 1; i > 0; i--) {
    // On choisit un index aléatoire STRICTEMENT inférieur à i
    // Math.random() * i -> intervalle [0, i[
    const j = Math.floor(Math.random() * i);
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  // On retourne le tableau mélangé
  return arr;
}
